var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FD6E26"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.813 5.572H6v6h4.813A2.19 2.19 0 0 0 12 9.729c0-.54-.33-1.016-.493-1.187c.394-.249.493-.875.493-1.158c0-.882-.493-1.5-1.187-1.812M7.286 6.857h2.785a.643.643 0 0 1 0 1.286H7.286zM10.07 9H7.286v1.286h2.785a.643.643 0 1 0 0-1.286",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.857 10.269V5.572h1.286v4.131l.514.583h3.772v1.286h-4.333zM6 17.096v-4.667h1.286v4.14l.557.574h2.374l.497-.574v-4.14H12v4.667l-1.183 1.333H7.24zm6.857-4.667h4.479c.493.192 1.093 1.024 1.093 1.667c0 .763-.378 1.105-.57 1.277l-.03.03c.201.128.6.531.6 1.11v1.916h-1.286V16.65c-.026-.201-.274-.728-.694-.793h-2.306v2.572h-1.286zm3.429.857h-2.143V15h2.143a.857.857 0 1 0 0-1.714"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur);
export default __webpack_public_path__ + "static/media/blur.f118b4210eb9e6a44a1cfcfe8506dd30.svg";
export { ForwardRef as ReactComponent };